import { useDispatch, useSelector } from "react-redux"
import {
  transformBarData,
  transformBoostData,
  transformBoostPoolData,
} from "./helpers"
import {
  fetchFerroBarUserDataAsync,
  fetchFerroBoostPoolDataAsync,
  fetchFerroBoostUserDataAsync,
} from "."
import { AppState } from ".."
import usePoller from "src/hooks/usePoller"
import { DeserializedBarData, DeserializedBoostData } from "./types"

export const usePollUserFerroBar = (account: string | null | undefined) => {
  const dispatch = useDispatch()
  usePoller(() => {
    dispatch(fetchFerroBarUserDataAsync(account))
  }, 5000)
}

export const useUserFerroBar = (): {
  barData: DeserializedBarData
} => {
  const { barData } = useSelector((state: AppState) => ({
    barData: state.xFer.barData,
  }))
  return { barData: transformBarData(barData) }
}

export const usePollUserFerroBoost = (account: string | null | undefined) => {
  const dispatch = useDispatch()
  usePoller(() => {
    if (account) {
      dispatch(fetchFerroBoostUserDataAsync(account))
    }
  }, 5000)
}

export const useUserFerroBoost = (): {
  boostData: DeserializedBoostData
} => {
  const { boostData } = useSelector((state: AppState) => ({
    boostData: state.xFer.boostData,
  }))
  return { boostData: transformBoostData(boostData) }
}

export const usePollFerroBoostPoolData = () => {
  const dispatch = useDispatch()
  usePoller(() => {
    dispatch(fetchFerroBoostPoolDataAsync())
  }, 5000)
}

export const useFerroBoostPool = () => {
  const { boostPoolData } = useSelector((state: AppState) => ({
    boostPoolData: state.xFer.boostPoolData,
  }))
  return { boostPoolData: transformBoostPoolData(boostPoolData) }
}
